// Thirdparty
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
// Styles
import "./../styles/Withdrawal.css";
// Assets
import helpIcon from "../assets/help-icon.svg";
import bitcoinIcon from "../assets/bitcoin-icon.svg";
import USDTIcon from "../assets/usdt-icon.svg";
import lightIcon from "../assets/light-icon.svg";
// Components
import Select from "../components/Select";
import Input from "../components/Input";
// Services
const Routes = require("./../services/routes.js");

async function fetchAccount(){
  try{
    const url = Routes.getAuthUserURL() + "/user";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {"content-type": "application/json"},
        credentials: 'include',
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch account: ${response.statusText} Status:${response.status}`);

      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
        return;
      }
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    // success
    return result;    
  }
  catch(err){
    console.error("Failed fetch account: ", err);
  }
}

async function fetchWithdrawal(payload){
  try{
    const url = Routes.getAuthWalletURL() + "/withdrawal";
    const origin = window.location.origin;
    console.debug(`Sending message to ${url} with origin ${origin}`);

    const response = await fetch(
      url,
      {
        method: "POST",
        headers: {"content-type": "application/json"},
        credentials: 'include',
        body: JSON.stringify(payload),
      }
    );
    const result = await response.json();

    // Failure
    if(!response.ok){
      console.error(`Failed to fetch account: ${response.statusText} Status:${response.status}`);

      // If the response was unauthorized
      if(response.status===401){
        localStorage.removeItem('verified'); // Remove verified
        window.location = `/`; // redirect the page to the home page.
        return;
      }
    }
    // Redirect
    else if (result.redirect){
      window.location = result.url;
      return;
    }
    else if(typeof result.verified !== 'undefined'){
      localStorage.verified = result.verified;
    }
    
    // success
    return result;
  }
  catch(err){
    console.error("Failed fetch account: ", err);
  }
}

function Withdrawal() {
  const [withdrawalValue, setWithdrawalValue] = useState("");
  const [networkValue, setNetworkValue] = useState("");
  const [withdrawAddress, setWithdrawAddress] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState(0);

  // Constants
  const minimumWithdrawal = 0.0001;
  const withdrawalOptions = [
    { value: "BTC", label: "BTC", icon: bitcoinIcon },
    { value: "USDT", label: "USDT", icon: USDTIcon },
  ];
  const networkOptions = [
    { value: "BITCOIN", label: "Bitcoin", icon: bitcoinIcon },
    { value: "LIGHTNING", label: "Lightning", icon: lightIcon },
  ];

  useEffect(() => {
    // Only can withdrawal if logged in!
    if (localStorage.verified===undefined){
      window.location = `/`; // redirect the page to the home page.
    }
  }, []);

  async function handleNetworkChange(value){
    setNetworkValue(value);
    setWithdrawAddress("");
    setWithdrawAmount("");
    fetchAccount({network: value, coin: withdrawalValue}).then(account =>{
      if (account){
        setMaxAmount(parseFloat(account.balance));
      }
    });
  }
  
  async function onWithdrawal(event){
    event.preventDefault();
    const payload = {
      network: networkValue.value,
      coin: withdrawalValue.value,
      address: withdrawAddress,
      amount: withdrawAmount,
    }
    fetchWithdrawal(payload).then(details => {
      console.log(details);
    })
  }

  return (
    <div className="withdrawalContainer">
      <div className="withdrawalWrapper">
        <div className="headingWrapper">
          <div className={`stepCount ${withdrawalValue && "step-active-color"}`}>
            1
          </div>
          <h3>Choose coin to withdraw</h3>
        </div>
        <div className="selectWrapper">
          <Select
            options={withdrawalOptions}
            value={withdrawalValue}
            handleChange={(value) => {
              setWithdrawalValue(value);
              setNetworkValue("");
              setWithdrawAddress("");
              setWithdrawAmount("");
            }}
          />
        </div>
        <div className="headingWrapper">
          <div className={`stepCount ${networkValue && "step-active-color"}`}>
            2
          </div>
          <h3>Choose a Network</h3>
        </div>
        <div className="selectWrapper">
          <Select
            options={networkOptions}
            value={networkValue}
            handleChange={handleNetworkChange}
            isDisabled={!withdrawalValue}
          />
        </div>
        <div className="headingWrapper">
          <div
            className={`stepCount ${
              withdrawAddress && withdrawAmount && "step-active-color"
            }`}
          >
            3
          </div>
          <h3>Confirm withdrawal details</h3>
        </div>

        <div className="input-wrapper">
          <Input
            placeholder="Enter address"
            label="Withdrawal Address"
            showAmount={false}
            value={withdrawAddress}
            disabled={
              !withdrawalValue ||
              !networkValue
            }
            onChange={(e) => setWithdrawAddress(e.target.value)}
          />
          <div className="amount-input">
            <Input
              placeholder="Enter amount"
              type="number"
              label="Amount"
              showAmount={true}
              amount={maxAmount}
              value={withdrawAmount}
              disabled={
                !withdrawalValue ||
                !networkValue
              }
              onChange={(e) => setWithdrawAmount(e.target.value)}
            />
            <div
              className={`max-text ${withdrawalValue && networkValue ? 'clickable' : 'disabled'}`}
              onClick={() => {
                if (withdrawalValue && networkValue){
                  setWithdrawAmount(maxAmount)
                }
              }}
            >
              Max
            </div>
          </div>
          <div className="withdraw-fee">
            Withdrawal Fee: <span> 0.000015 BTC</span>
          </div>
        </div>

        <div>
          <div className="withdrawal-info">
            <div className="flex-row">
              <p>Minimum Withdrawal Amount</p>
              <img data-tooltip-id="withdrawal-amount" src={helpIcon} alt="info" />
            </div>
            <Tooltip
              id="withdrawal-amount"
              place="top"
              content="Withdrawals below the minimum will be lost"
            />
            <p>{minimumWithdrawal} BTC</p>
          </div>
        </div>
        <div className="acknowledge-btn-wrapper">
          <button
            type="button"
            className="acknowledge-btn"
            disabled={
              !withdrawalValue ||
              !networkValue ||
              !withdrawAmount ||
              !withdrawAddress ||
              withdrawAmount < minimumWithdrawal
            }
            onClick={onWithdrawal}
          >
            Withdrawal
          </button>
        </div>
      </div>
      <div className="FAQ-container">
        <h2>FAQ</h2>

        <ul>
          <li>Withdrawal Unreceived?</li>
          <li>Arrival times</li>
        </ul>
      </div>
    </div>
  );
}

export default Withdrawal;
